import {
	ExternalIntegrationRepository,
	ExternalIntegrationNavBar,
	BasicExternalIntegration,
	ExternalIntegrationTab,
} from '@warehouse/object-browser/core';
import { singletonFactory } from '@warehouse/shared/util';
import integrations from '../../../src/assets/json-administration-profiles/available-integrations/available-integrations.json';

/**
 * This is a safe cast because we test the structure with a unit test in tenants.json
 */

const availableIntegrations = integrations as Array<
	BasicExternalIntegration | ExternalIntegrationTab | ExternalIntegrationNavBar
>;

export class ExternalIntegrationRepositoryJson implements ExternalIntegrationRepository {
	public getAvailable(): BasicExternalIntegration[] {
		return availableIntegrations.filter(
			(integration) =>
				integration.id !== 'nxTensionNavBar' &&
				integration.id !== 'nxTension' &&
				integration.id !== 'nxOrders' &&
				integration.id !== 'nxInventory',
		);
	}

	public getNavBar(): ExternalIntegrationNavBar | undefined {
		return availableIntegrations.find(
			(integration): integration is ExternalIntegrationNavBar => integration.id === 'nxTensionNavBar',
		);
	}

	public getExternalTab(config: string): ExternalIntegrationTab | undefined {
		return availableIntegrations.find(
			(integration): integration is ExternalIntegrationTab => integration.id === config,
		);
	}
}

export const externalIntegrationsRepositorySingleton = singletonFactory<ExternalIntegrationRepository>({
	factory: () => new ExternalIntegrationRepositoryJson(),
});
